import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import urlBase from '@/utils/urlBase'

import { querySummaryByMonth, querySummaryByWeeks, queryTimeZoom, getAllClass, queryStudent, queryAllMainTeacher, getMentorList, getTechnologyTaList, queryIpqSupervisorCommon } from '@/api'
@Component({ name: 'schedule-page' })
export default class SchedulePage extends Vue {
  private searchStudentOptions: any =[] // 学生列表
  private searchClassOptions: any =[] // 班级列表
  private searchMentorOptions: any =[] // mentor列表
  private searchMainOptions: any = [] // 主导师
  private searchTechnologyTaOptions: any = [] // 科研组教
  private searchIpqSupervisorOptions: any = [] // ipq
   private searchData: any = { // 搜索data
     searchStudentData: '',
     searchClassData: '',
     teacherId: '',
     timeAreaChoose: 8
   }

  private showTypeChoose = '周'
  private timeAreaOptions = []
  private classStudentOptions: any = [{ value: 1, name: '按班级查询' }, { value: 2, name: '按学生查询' }, { value: 3, name: '按主导师查询' }, { value: 4, name: '按Mentor查询' }, { value: 5, name: '按科研助教查询' }, { value: 6, name: '按Supervisor查询' }]
  private classStudentFind: any = ''
  private currentName: any = ''
  private showPanelDay = 0;
  private showPanelDayrelation = 0;
  private scheduleList: any = []
  private scheduleListWeek: any = []
  private exportDialogVisible = false
  private exportTimeRange = ''
  private currentChoose: any = null
  private timeList: any = []
  private courseList = []
  private weekI: any = 0;
  private monthI: any = 0;
  private loading: any = false
  private time: any = null
  created () {
    // 班级详情 和 学员详情 跳转课表查询默认数值
    if (this.$route.query.classId) {
      this.searchData.searchClassData = this.$route.query.classId
      this.currentName = this.$route.query.className
      this.classStudentFind = 1
    }
    if (this.$route.query.studentId) {
      this.searchData.searchStudentData = this.$route.query.studentId
      this.currentName = this.$route.query.studentnameCn
      this.classStudentFind = 2
    }
    // 主导师，mentor，科研助教查看查看课表
    const lookType: any = Number(this.$route.query.lookType)
    if (lookType === 3) {
      this.classStudentFind = 3
      this.searchData.teacherId = this.$route.query.teacherId
      this.currentName = this.$route.query.teacherName
    }
    if (lookType === 4) {
      this.searchData.teacherId = this.$route.query.teacherId
      this.currentName = this.$route.query.teacherName
      this.classStudentFind = 4
    }
    if (lookType === 5) {
      this.searchData.teacherId = this.$route.query.teacherId
      this.currentName = this.$route.query.teacherName
      this.classStudentFind = 5
    }
    if (lookType === 6) {
      this.searchData.teacherId = this.$route.query.teacherId
      this.currentName = this.$route.query.teacherName
      this.classStudentFind = 6
    }
    this.initTimeList()
    this.currentChoose = moment()
    // this.initPageClassData()// 获取班级class
    // this.initPagestudentData()
    this.initPageMentorData()
    this.queryTimeZoom()
    this.onScheduleTypeChange()
  }

  private async queryTimeZoom () { // 查询时区
    const result: any = await queryTimeZoom({})
    this.timeAreaOptions = result.zoneList
  }

  private initTimeList () {
    this.timeList = []
    for (let index = 0; index <= 23; index++) {
      this.timeList.push(`${index}:00`)
    }
  }

  private initScheduleList () {
    if (this.showTypeChoose === '月') {
      this.scheduleList = this.monthDay(this.currentChoose)
      this.getMonthInnerList()
    } else {
      this.scheduleListWeek = this.monthWeek(this.currentChoose)
    }
  }

  // 切换清空数据
  private onClassStudentChange () {
    this.currentName = ''
    this.searchData.searchStudentData = ''
    this.searchData.searchClassData = ''
    this.searchData.teacherId = ''
    // if (this.classStudentFind === 1) {
    //   this.searchData.searchStudentData = ''
    //   this.searchData.teacherId = ''
    //   this.currentName = ''
    // } else if (this.classStudentFind === 2) {
    //   this.searchData.searchClassData = ''
    //   this.searchData.teacherId = ''
    //   this.currentName = ''
    // } else {
    //   this.searchData.searchStudentData = ''
    //   this.searchData.searchClassData = ''
    //   this.currentName = ''
    // }
    this.onScheduleTypeChange()
  }

  private async initSummaryTimetable () {
    this.courseList = []
    if (!this.currentName) return
    const obj: any = {
      timeZone: this.searchData.timeAreaChoose,
      classId: this.searchData.searchClassData,
      studentId: this.searchData.searchStudentData,
      teacherId: this.searchData.teacherId
    }
    if (this.showTypeChoose === '月') {
      obj.month = this.monthI
      const projectTesult: any = await querySummaryByMonth(obj)
      this.courseList = projectTesult
    } else {
      obj.week = this.weekI
      const projectTesult: any = await querySummaryByWeeks(obj)
      this.courseList = projectTesult.weekList
    }
  }

  private async initPageClassData () {
    const result: any = await getAllClass({})
    this.searchClassOptions = result
  }

  private async initPagestudentData () {
    const result: any = await queryStudent({})
    this.searchStudentOptions = result
  }

  private async initPageMentorData () {
    const result: any = await queryAllMainTeacher({})
    this.searchMainOptions = result
    const result1: any = await getMentorList({})
    this.searchMentorOptions = result1
    const result2: any = await getTechnologyTaList({})
    this.searchTechnologyTaOptions = result2
    const result3: any = await queryIpqSupervisorCommon({})
    this.searchIpqSupervisorOptions = result3
  }

  get today () {
    return moment()
  }

  get currentDate () {
    return moment(this.currentChoose).format('YYYY年MM月')
  }

  get tipTypeName () {
    let name: any = null
    if (this.classStudentFind === 1) {
      name = '班级'
    } else if (this.classStudentFind === 2) {
      name = '学生'
    } else if (this.classStudentFind === 3) {
      name = '主导师'
    } else if (this.classStudentFind === 4) {
      name = 'Mentor'
    } else if (this.classStudentFind === 5) {
      name = '科研助教'
    } else if (this.classStudentFind === 6) {
      name = 'Supervisor'
    }
    return name
  }

  private monthWeek (date: any) {
    const dateList = []
    // 看一下今天星期几
    const nowWeek = moment(date).weekday() === 0 ? 7 : moment(date).weekday()
    // 本周的第一天是
    const firstDayOfWeek = moment(date).subtract(nowWeek, 'day')
    for (let index = 0; index < 7; index++) {
      const buffer = firstDayOfWeek.add(1, 'day')
      dateList.push({
        day: buffer.format('D'),
        month: buffer.format('M'),
        year: buffer.format('YYYY'),
        week: buffer.format('d'),
        isToday: buffer.format('YYYYMMDD') === moment().format('YYYYMMDD')
      })
    }
    return dateList
  }

  private monthDay (date: any) {
    const month = date.format('MM')
    const year = date.format('YYYY')
    const daysArr: any = [[], [], [], [], [], []] // 6*7的日历数组
    const currentWeekday = moment(date).date(0).weekday()
    const lastMonthDays = moment(date).subtract(1, 'month').daysInMonth() // 获取上月天数
    const currentMonthDays = moment(date).daysInMonth() // 获取当月天数
    const getDay = (day: any) => {
      if (day <= lastMonthDays) { // 如果当前天小于等于上个月的天数 说明是上个月
        return { day, type: 'before' }
      } else if (day <= (lastMonthDays + currentMonthDays)) {
        return { day: day - lastMonthDays, type: 'target', isToday: moment().format('YYYYMMD') === `${year}${month}${day - lastMonthDays}` } // 本月
      } else {
        return { day: day - (lastMonthDays + currentMonthDays), type: 'after' } // 下个月
      }
    }
    for (let i = 0; i < 7; i += 1) { // i是列 一共有7列 代表一周的七天
      const virtualDay = (lastMonthDays - currentWeekday) + i + 1
      for (let j = 0; j < 6; j += 1) { // j是行 一共有6行
        daysArr[j][i] = getDay(virtualDay + (j * 7))
      }
    }

    return daysArr
  }

  // 导出课表
  private onExportClicked () {
    // todo 需要修改线上的IP地址
    // const url = 'http://192.168.0.33:10069/timetable/export?timeZone=' +
    const url = urlBase.eduBaseUrl + 'timetable/export?timeZone=' +
    this.searchData.timeAreaChoose + '&classId=' +
    this.searchData.searchClassData + '&studentId=' +
    this.searchData.searchStudentData + '&teacherId=' +
    this.searchData.teacherId + '&startAt=' +
    String(new Date((new Date(this.exportTimeRange[0])).toDateString()).getTime()) +
    '&endAt=' + String(new Date((new Date(this.exportTimeRange[1])).toDateString()).getTime())
    const a: any = document.createElement('a')
    a.href = url //  URL对象
    a.click() // 模拟点击
    this.exportDialogVisible = false
  }

  // 时区被切换
  private onTimeAreaChange (data: any) {
    this.onScheduleTypeChange()
  }

  private remoteMethod (query: any) {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      if (query !== '') {
        this.loading = true
        const result: any = await getAllClass({ name: query })
        this.searchClassOptions = result
        this.loading = false
      } else {
        this.searchClassOptions = []
        this.loading = false
      }
    }, 600)
  }

  private remoteMethod1 (query: any) {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      if (query !== '') {
        this.loading = true
        const result: any = await queryStudent({ name: query })
        this.searchStudentOptions = result
        this.loading = false
      } else {
        this.searchStudentOptions = []
        this.loading = false
      }
    }, 600)
  }

  // // 班级被切换 学生被切换
  private onClassChange () {
    let obj: any = {}
    obj = this.searchClassOptions.find((item: any) => {
      return item.classId === this.searchData.searchClassData
    })
    this.currentName = obj ? obj.className : ''
    this.onScheduleTypeChange()
  }

  // 切换查询条件
  private onteacherChange () {
    let obj: any = {}
    if (this.classStudentFind === 2) {
      obj = this.searchStudentOptions.find((item: any) => {
        return item.id === this.searchData.searchStudentData
      })
    }
    if (this.classStudentFind === 3) {
      obj = this.searchMainOptions.find((item: any) => {
        return item.id === this.searchData.teacherId
      })
    }
    if (this.classStudentFind === 4) {
      obj = this.searchMentorOptions.find((item: any) => {
        return item.id === this.searchData.teacherId
      })
    }
    if (this.classStudentFind === 5) {
      obj = this.searchTechnologyTaOptions.find((item: any) => {
        return item.id === this.searchData.teacherId
      })
    }
    if (this.classStudentFind === 6) {
      obj = this.searchIpqSupervisorOptions.find((item: any) => {
        return item.id === this.searchData.teacherId
      })
    }
    this.currentName = obj ? obj.name : ''
    this.onScheduleTypeChange()
  }

  // 课表的时间切换
  private async onTimeChanged (data: string) {
    if (data === '前') {
      if (this.showTypeChoose === '月') {
        this.monthI = this.monthI - 1
        this.currentChoose = moment(this.currentChoose).subtract(1, 'month')
      } else if (this.showTypeChoose === '周') {
        this.weekI = this.weekI - 1
        this.currentChoose = moment(this.currentChoose).subtract(1, 'week')
      }
    } else if (data === '本月' || data === '本周') {
      this.weekI = 0
      this.monthI = 0
      this.currentChoose = this.today
    } else if (data === '后') {
      if (this.showTypeChoose === '月') {
        this.monthI = this.monthI + 1
        this.currentChoose = moment(this.currentChoose).add(1, 'month')
      } else if (this.showTypeChoose === '周') {
        this.weekI = this.weekI + 1
        this.currentChoose = moment(this.currentChoose).add(1, 'week')
      }
    }
    await this.initSummaryTimetable()
    this.initScheduleList()
  }

  private async onScheduleTypeChange () {
    this.loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    await this.initSummaryTimetable()
    await this.initScheduleList()
    this.loading.close()
  }

  private getMonthInnerList () {
    for (let i = 0; i < this.scheduleList.length; i++) {
      for (let j = 0; j < this.scheduleList[i].length; j++) {
        const buffer = this.scheduleList[i][j]
        if (buffer.type !== 'target') continue
        const day = buffer.day
        const list = this.courseList.filter((item: any) => { return item.time * 1 === day * 1 })
        this.scheduleList[i][j].course = list
      }
    }
  }
}
